export var SpeechErrorEventCode;
(function (SpeechErrorEventCode) {
    SpeechErrorEventCode["UNKNOWN"] = "Unknown";
    SpeechErrorEventCode["CONNECTION_RETRY"] = "ConnectionRetry";
    SpeechErrorEventCode["CONNECTION_RETRY_FAILURE"] = "ErrorConnectionRetryFailure";
    SpeechErrorEventCode["SPEECH_HANDLER_WS_FAILURE"] = "ErrorSpeechHandlerWebSocketFailure";
    SpeechErrorEventCode["PROTOBUF_DESERIALIZATION_FAILURE"] = "ErrorProtobufDeserializationFailure";
    SpeechErrorEventCode["EXPLICITLY_DISABLED"] = "ExplicitlyDisabled";
    SpeechErrorEventCode["SPEECH_RECOGNITION_CANCELED"] = "ErrorSpeechRecognitionCanceled";
    /**
     * TODO: Other errors examples:
     * PFA_TOKEN_FETCH_ERROR
     * LUIS_APP_NOT_FOUND
     * LUIS_RATE_LIMIT_HIT
     * LUIS_TIMEOUT
     * LUIS_BAD_ACCESS_KEY
     */
})(SpeechErrorEventCode || (SpeechErrorEventCode = {}));
export var SpeechErrorEventState;
(function (SpeechErrorEventState) {
    /** low level error state and client can choose log it or ignore. */
    SpeechErrorEventState["INTERMITTENT"] = "Intermittent";
    /** High level error state that recommends client do some actions for it. */
    SpeechErrorEventState["FINAL"] = "Final";
})(SpeechErrorEventState || (SpeechErrorEventState = {}));
export var SpeechErrorEventImpact;
(function (SpeechErrorEventImpact) {
    SpeechErrorEventImpact["NO_DICTATION"] = "NoDictation";
    SpeechErrorEventImpact["NO_COMMANDING"] = "NoCommanding";
    SpeechErrorEventImpact["NO_TOKEN"] = "NoPfaToken";
})(SpeechErrorEventImpact || (SpeechErrorEventImpact = {}));
export var VoiceResponseVersion;
(function (VoiceResponseVersion) {
    VoiceResponseVersion["version1"] = "1";
    VoiceResponseVersion["version2"] = "2";
})(VoiceResponseVersion || (VoiceResponseVersion = {}));
export var VoiceCommandError;
(function (VoiceCommandError) {
    VoiceCommandError[VoiceCommandError["NoMatch"] = 0] = "NoMatch"; // The utterance couldn't be resolved to any command.
})(VoiceCommandError || (VoiceCommandError = {}));
export var BatchTranscriptionErrorCode;
(function (BatchTranscriptionErrorCode) {
    BatchTranscriptionErrorCode["INTERNAL_ERROR"] = "INTERNAL_ERROR";
    BatchTranscriptionErrorCode["UNSUPPORTED_FILE_FORMAT"] = "UNSUPPORTED_FILE_FORMAT";
    BatchTranscriptionErrorCode["UPLOADING"] = "UPLOADING";
    BatchTranscriptionErrorCode["PROCESSING"] = "PROCESSING";
    BatchTranscriptionErrorCode["DELETED"] = "DELETED";
    BatchTranscriptionErrorCode["FILE_NOT_EXIST"] = "FILE_NOT_EXIST";
    BatchTranscriptionErrorCode["FILE_DECODE_ERROR"] = "FILE_DECODE_ERROR";
    BatchTranscriptionErrorCode["REQUEST_TIMEOUT_ERROR"] = "REQUEST_TIMEOUT_ERROR"; // Error from GetBatchTranscription call timing out
})(BatchTranscriptionErrorCode || (BatchTranscriptionErrorCode = {}));
//# sourceMappingURL=annotations.js.map